import React, { useState, useEffect, useRef } from "react";
import { isUndefined, size, map } from "lodash";
import ApiEngine from "../../util/ApiEngine";
import { useForm, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import {
  ApiKey, ApiUrl, SessionKey, WebUrl,
  LanguageOption,
} from "../../util/Constant";
import { stringIsNullOrEmpty, createFormBody, numberWithCommas, numberWithCurrencyFormat2, isObjectEmpty, createMultiPartFormBody } from "../../util/Util";
import { useDispatch, useSelector } from "react-redux";
import {
  setActiveTab,
  setBusy,
  setDownlineQuery,
  setDownlineSearchText,
  setIdle,
  setPageSize,
  setY,
  showResponseMessage,
} from "../../redux/AppAction";
const closedEye = "/img/v3/hide.png";
const openEye = "/img/v3/eye-blue.png";

const ChangePassword = (props) => {
  const { t, i18n } = useTranslation();
  const _dispatch = useDispatch();
  const _MIN_PASSWORD_LENGTH = 6;
  const [isHiddenCurrentPassword, setIsHiddenCurrentPassword] = useState(closedEye);
  const [isHiddenNewPassword, setIsHiddenNewPassword] = useState(closedEye);
  const [isHiddenConfirmPassword, setIsHiddenConfirmPassword] = useState(closedEye);
  const [currentPasswordVisible, setCurrentPasswordVisible] = useState(false);
  const [newPasswordVisible, seNewPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);

  const {
    errors: resetPasswordErrors,
    handleSubmit: handleResetPasswordSubmit,
    watch: resetPasswordWatch,
    setValue: setResetPasswordValue,
    setError: setResetPasswordError,
    clearErrors: clearResetPasswordErrors,
    register: resetPasswordRegister,
  } = useForm();

  async function submitResetPasswordForm(data) {

    var responseJson = await ApiEngine.post(
      ApiUrl._API_MEMBER_RESET_PASSWORD,
      createMultiPartFormBody(data)
    );

    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      setResetPasswordValue("currentPassword", "");
      setResetPasswordValue("password", "");
      setResetPasswordValue("confirmPassword", "");
      clearResetPasswordErrors();
    }
    _dispatch(
      showResponseMessage(
        responseJson[ApiKey._API_SUCCESS_KEY],
        responseJson[ApiKey._API_MESSAGE_KEY]
      )
    );
  }


  // toggle current password, password & confirm password
  const toggleHiddenCurrentPassword = () => {
    setCurrentPasswordVisible(!currentPasswordVisible);
    if (isHiddenCurrentPassword === closedEye) {
      setIsHiddenCurrentPassword(openEye);
    } else {
      setIsHiddenCurrentPassword(closedEye);
    }
  };


  const toggleHiddenNewPassword = () => {
    seNewPasswordVisible(!newPasswordVisible);
    if (isHiddenNewPassword === closedEye) {
      setIsHiddenNewPassword(openEye);
    } else {
      setIsHiddenNewPassword(closedEye);
    }
  };
  const toggleHiddenConfirmPassword = () => {
    setConfirmPasswordVisible(!confirmPasswordVisible);
    if (isHiddenConfirmPassword === closedEye) {
      setIsHiddenConfirmPassword(openEye);
    } else {
      setIsHiddenConfirmPassword(closedEye);
    }
  };



  return (
    <>
      <form onSubmit={handleResetPasswordSubmit(submitResetPasswordForm)} id="changePassword">
        <div className="custom-container-box-my-profile">
        <div className="withdraw-form-input">
          <div className="first">
              {t("CURRENT_PASSWORD")} :
          </div>
          <div className="second">
            <div class="custom-input-text">
              <div className="with-show-password-input-profile">
                <input
                  type={currentPasswordVisible ? "text" : "password"}
                  name="currentPassword"
                  className="custom-input-style-1"
                  placeholder={t("CURRENT_PASSWORD")}
                  autoComplete="off"
                  autoFill="off"
                  ref={resetPasswordRegister({
                    required: "REQUIRED_OLD_PASSWORD",
                  })}
                  errors={resetPasswordErrors}
                />
                <div
                  className="image"
                  onClick={toggleHiddenCurrentPassword}
                >
                  <img
                    src={isHiddenCurrentPassword}
                    className="img-responsive"
                    alt="referral-code"
                  />
                </div>
              </div>
              <div className="invalid-feedback">
                {resetPasswordErrors.currentPassword
                  ? t(resetPasswordErrors.currentPassword.message)
                  : ""}
              </div>
            </div>
          </div>
        </div>
          <div className="withdraw-form-input mt-2">
          <div className="first">
            {t("ENTER_NEW_PASSWORD")} :
          </div>
          <div className="second">
            <div class="custom-input-text">
              <div className="with-show-password-input-profile">
                <input
                  type={newPasswordVisible ? "text" : "password"}
                  name="password"
                  className="custom-input-style-1"
                  placeholder={t("ENTER_NEW_PASSWORD")}
                  autoComplete="off"
                  autoFill="off"
                  ref={resetPasswordRegister({
                    required: "REQUIRED_NEW_PASSWORD",
                    minLength: {
                      value: _MIN_PASSWORD_LENGTH,
                      message: t("MIN_CHARACTERS", {
                        length: _MIN_PASSWORD_LENGTH,
                      }),
                    },
                    pattern: {
                      value: /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*()_+]).{6,}$/i,
                      message: "PASSWORD_REGEX_VALIDATE",
                    },
                    validate: (value) =>
                      resetPasswordWatch("currentPassword") === "" ||
                      value !== resetPasswordWatch("currentPassword") ||
                      "NEW_PASSWORD_SAME_AS_OLD_PASSWORD",
                  })}
                  errors={resetPasswordErrors}
                />
                <div
                  className="image"
                  onClick={toggleHiddenNewPassword}
                >
                  <img
                    src={isHiddenNewPassword}
                    className="img-responsive"
                    alt="referral-code"
                  />
                </div>
                </div>
              <div className="invalid-feedback">
                {resetPasswordErrors.password
                  ? t(resetPasswordErrors.password.message)
                  : ""}
                </div>
                <div className="reg-notice">
                  {t("REGISTER_REMINDER_PASSWORD_PART_1")}
                </div>
            </div>
          </div>
        </div>
          <div className="withdraw-form-input mt-2 mb-2">
          <div className="first">
              {t("ENTER_CONFIRM_NEW_PASSWORD")} :
          </div>
          <div className="second">
            <div class="custom-input-text">
              <div className="with-show-password-input-profile">
                <input
                  type={confirmPasswordVisible ? "text" : "password"}
                  name="confirmPassword"
                  className="custom-input-style-1"
                  placeholder={t("ENTER_CONFIRM_NEW_PASSWORD")}
                  autoComplete="off"
                  autoFill="off"
                  ref={resetPasswordRegister({
                    required: "REQUIRED_CONFIRM_NEW_PASSWORD",
                    validate: (value) =>
                      resetPasswordWatch("password") === "" ||
                      value === resetPasswordWatch("password") ||
                      "PASSWORD_MISMATCH",
                  })}
                  errors={resetPasswordErrors}

                />
                <div
                  className="image"
                    onClick={toggleHiddenConfirmPassword}
                >
                  <img
                    src={isHiddenConfirmPassword}
                    className="img-responsive"
                    alt="referral-code"
                  />
                </div>
                </div>
              <div className="invalid-feedback">
                {resetPasswordErrors.confirmPassword
                  ? t(resetPasswordErrors.confirmPassword.message)
                  : ""}
              </div>
            </div>
          </div>
        </div>
        <div className="withdraw-form-input">
          <div className="first">

          </div>
          <div className="second">
              <button class="custom-btn-new">{t("SUBMIT")}</button>
          </div>
        </div>
        </div>
      </form>
    </>
  )
};
export default ChangePassword;
